import React, {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import {Row, Col, Container} from "reactstrap";
import HonorCardIcon from "../images/honor-card.svg";
import DonateIcon from "../images/donate.svg";
import DonateBalanceIcon from "../images/donate-balance.svg";
import {GetCharityInfo} from "../Code/Data";
import MainPage from "./../Components/Shared/MainPage";
import PurchaseItems from './../Components/Common/PurchaseItems';
import SinglePurchaseItem from './../Components/Common/SinglePurchaseItem';

export default function Support() {
  const {charityIdOrName} = useParams(),
    [charityInfo, setCharityInfo] = useState({
      CharityId: 0,
      CharityName: "Your Charity",
      CategoryName: "Other",
    });

  useEffect(() => {
    (async function f() {
      const result = await GetCharityInfo(charityIdOrName);
      if (result.CharityName) {
        setCharityInfo(result);
        document.title = `Support ${result.CharityName}`;
      }
    })();
  }, [charityIdOrName]);

  return (
    <MainPage
      title={`Support ${charityInfo.CharityName} and ${charityInfo.CategoryName} causes `}
      description={
        <Row className="justify-content-md-center">
          {charityInfo.LogoURL && (
            <Col lg={3} className="text-center align-middle">
              <img
                src={charityInfo.LogoURL}
                style={{maxWidth: "100%"}}
                alt={charityInfo.CharityName}
                className="inline"
              />
            </Col>
          )}
          <Col className="text-center md-auto">
            {charityInfo.ShortDescription &&
              <span dangerouslySetInnerHTML={{__html: charityInfo.ShortDescription}} />}
          </Col>
        </Row>
      }>
      {charityInfo.CharityId > 0 && (
        <section>
          <Container fluid>
            <Row className="section-title-row">
              <Col xs="12" className="text-center stepWay">
                <h2>{`Support ${charityInfo.CharityName}`}</h2>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <SinglePurchaseItem caption='Honor Cards'
                icon={HonorCardIcon}
                iconAlt='CharityChoice Honor Cards'
                text={`Make a donation to ${charityInfo.CharityName} "in honor of" your recipient.`}
                url={`/Purchase/HonorCards/?CharityId=${charityInfo.CharityId}`}
                buttonText='Give Honor Cards' />
              <SinglePurchaseItem caption='Make A Direct Donation'
                icon={DonateIcon}
                iconAlt='Donate to charity'
                text={`Use your credit card to donate through us to ${charityInfo.CharityName}`}
                url={`/Purchase/DirectToCharityDonation/?CHID=${charityInfo.CharityId}`}
                buttonText='Donate Directly' />
              <SinglePurchaseItem caption='Donate Gift Card Balance'
                icon={DonateBalanceIcon}
                iconAlt='Donate Gift Card Balance'
                text={`Use your retail gift card balance to make a donation to ${charityInfo.CharityName}.`}
                url={`/GCE/?CID${charityInfo.CharityId}`}
                buttonText='Donate Balance' />
            </Row>
          </Container>
        </section>
      )}
      <section>
        <Container fluid>
          {charityInfo.CharityId > 0 && (
            <Row className="section-title-row">
              <Col xs="12" className="text-center stepWay">
                <h2>{`Support ${charityInfo.CategoryName} and other causes that resonate with you`}</h2>
              </Col>
            </Row>
          )}
          <PurchaseItems />
        </Container>
      </section>
    </MainPage>
  );
}
